import { useBaseRootActions } from '../baseRoot.actions';

function useEmpresasActions() {
  const baseActions = useBaseRootActions('empresas');

  return {
    list: baseActions.list,
    get: baseActions.get,
    create: baseActions.create,
    update: baseActions.update,
    delete: baseActions.delete,
  };
}

export { useEmpresasActions };
